<template>
    <c-modal :value="isOpen" title="Image Effects" size="xl" @closed="handleClose">
        <image-effects-properties-modals-add-header />
        <image-effects-properties-modals-add-body />
        <template #modal-footer>
            <div class="d-flex justify-content-end">
                <c-button text="Cancel" variant="secondary" @click="handleClose" />
            </div>
        </template>
    </c-modal>
</template>

<script setup lang="ts">
import { watch, computed } from 'vue';
import store from '@/store';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';

import ImageEffectsPropertiesModalsAddHeader from './components/header/ImageEffectsPropertiesCreateHeader.vue';
import ImageEffectsPropertiesModalsAddBody from './components/body/ImageEffectsPropertiesCreateBody.vue';

const isOpen = computed(() => {
    return store.state.imageEffectsProperties?.modalAddIsOpen || false;
});

const handleClose = () => {
    store?.dispatch('imageEffectsProperties/closeAddModal');
};

const resetForm = () => {
    store.dispatch('imageEffectsProperties/resetModalState');
};

watch(
    () => isOpen.value,
    () => {
        if (!isOpen.value) {
            resetForm();
        }
    }
);
</script>
